import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { FileDown, FileText, FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";

const download = async (kind, formato, params) => {
  try {
    const r = await api.get(`/report/${kind}`, { params: { ...params, formato }, responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${kind}_${!params.company || params.company === "all" ? "consolidato" : params.company}_${params.mese || params.anno}.${formato}`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  } catch (e) {
    let msg = "Errore durante l'esportazione";
    try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch {}
    toast.error(msg);
  }
};

export const ReportExport = ({ kind, params, completoParams, testId }) => {
  const [busy, setBusy] = useState(false);
  const run = async (k, f, p) => { setBusy(true); await download(k, f, p); setBusy(false); };
  const Item = ({ k, f, p, label }) => (
    <DropdownMenuItem onClick={() => run(k, f, p)} data-testid={`${testId}-${k}-${f}`} className="gap-2">
      {f === "pdf" ? <FileText className="w-4 h-4" /> : <FileSpreadsheet className="w-4 h-4" />}{label}
    </DropdownMenuItem>
  );
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="outline" className="h-8 gap-1" disabled={busy} data-testid={testId}>
          <FileDown className="w-4 h-4" />{busy ? "Esporto…" : "Esporta"}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>Questa pagina</DropdownMenuLabel>
        <Item k={kind} f="pdf" p={params} label="Scarica PDF" />
        <Item k={kind} f="xlsx" p={params} label="Scarica Excel" />
        <DropdownMenuSeparator />
        <DropdownMenuLabel>Report completo (risultato + investimento)</DropdownMenuLabel>
        <Item k="completo" f="pdf" p={completoParams} label="PDF completo" />
        <Item k="completo" f="xlsx" p={completoParams} label="Excel completo" />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
